import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field, getFormValues, change } from 'redux-form';
import { withRouter } from 'react-router';
import v from 'validate.js';
import styles from './style.module.css';
import * as Routes from '../../../../../constants/routes';
import { onSubmit } from '../../../../../common/components/submit-button';
import RenderTextarea from '../../../../../common/components/render-input/text-area';
import { trackingEvent } from '../../../../../helpers/tracking';

const tracking = {
    eventAction: 'Prosperity Planner - Step 2',
    eventLabel: 'Starting Points'
};

export const formName = Routes.STEPTWO;

export const formDetails = {
    key: 'startingPoint',
    title: 'Starting Points',
    formName,
    totalKey: 'startingPoint',
    fields: {
        familyAndFriends: {
            label: 'Family and Friends',
            placeholder: 'I want to focus on...',
            required: false
        },
        fun: {
            label: 'Fun',
            placeholder: 'I want to have...',
            required: false
        },
        home: {
            label: 'Home',
            placeholder: 'I want to live...',
            required: false
        },
        community: {
            label: 'Community',
            placeholder: 'I want to engage...',
            required: false
        },
        career: {
            label: 'Career',
            placeholder: 'I want to pursue...',
            required: false
        }
    }
};

const minValue = '';

const validate = values => v(values,
    Object.entries(formDetails.fields).reduce((obj, [ key, field ]) => ({
        ...obj,
        [key]: {
            presence: {
                allowEmpty: !field.required,
                message: 'is required'
            }
        }
    }), {})
);

class StepTwoForm extends Component {
    render() {
        return (
            <form className={styles.form}>
                {
                    Object.keys(formDetails.fields).map(key => (
                        <Field
                            key={key}
                            type='text'
                            name={key}
                            label={formDetails.fields[key].label}
                            tooltip={formDetails.fields[key].tooltip}
                            component={RenderTextarea}
                            required={formDetails.fields[key].required}
                            placeholder={formDetails.fields[key].placeholder}
                        />
                    ))
                }
            </form>
        );
    }
}

const formValues = getFormValues(formName);

const mapStateToProps = (state) => ({
    formValues: formValues(state),
    paginationSkipState: state.calculator.paginationHasSkip,
});

const mapDispatchToProps = (dispatch) => ({
    changeFieldValue: (field, value) => dispatch(change(formName, field, value))
});

StepTwoForm = reduxForm({
    form: formName,
    destroyOnUnmount: false,
    validate,
    onSubmit,
    initialValues: Object.keys(formDetails.fields).reduce((obj, val) => ({
        ...obj,
        [val]: minValue
    }), {}),
    skipPath: `/prosperity-planner${Routes.SUMMARY}`,
    redirectPath: `/prosperity-planner${Routes.STEPTHREE}`,
    pagination: {
        previous: {
            path:  `/prosperity-planner${Routes.STEPTHREE}`
        }
    },
    tracking: () => trackingEvent(tracking)
})(StepTwoForm);

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(StepTwoForm));

